import { lazyLoad } from 'utils/loadable';

export const ARSettings = lazyLoad(
  () => import('./index'),
  module => module.ARSettings,
); 